import { Box } from '@mui/material'
import { C1TableRedux } from 'components/core/list/C1Table/C1TableRedux'
import List from 'components/core/list/index'
import { useErrorReporting } from 'components/no-ui/error-reporting/datadog'
import { ExportData } from 'components/pages/explore/query/ExportData'
import { QUERIES } from 'components/pages/explore/query/Query'
import { cols } from 'components/pages/explore/query/Results/AppUsers'
import { StructuredSearchStyles } from 'components/pages/explore/query/styles'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { AppUserDomain, AppUserServiceSearchRequest, AppUserStatus_Status } from 'pbts/c1/api/app/v1/app_user'
import { ExportDataRequest, QueryId } from 'pbts/c1/api/exportdata/v1/exportdata'
import { FC, useCallback, useMemo, useState } from 'react'
import { searchAppUsersApi } from 'redux_toolkit/app-users'

const searchRequest = AppUserServiceSearchRequest.create({
    appUserDomains: [AppUserDomain.EXTERNAL],
    appUserStatuses: [AppUserStatus_Status.ENABLED],
    expandMask: { paths: ['*'] },
})

const exportDataActionRequest = ExportDataRequest.create({
    queryId: QueryId.ACTIVE_EXTERNAL_ACCOUNTS,
    request: {
        oneofKind: 'appUserServiceSearchRequest',
        appUserServiceSearchRequest: searchRequest,
    },
})

export const ActiveExternalAccountsReport: FC = () => {
    const [page, setPage] = useState<number>(0)
    const { data, isError, isLoading, getPage, canLoadMore, error } = searchAppUsersApi.useSearch(
        searchRequest,
        {},
    )

    const onPageChange = useCallback(
        async (n: number) => {
            await getPage(n)
            setPage(n)
        },
        [getPage],
    )

    useErrorReporting(isError, error, QUERIES.ActiveExternalAccounts)

    const accountTable = useMemo(
        () => (
            <C1TableRedux
                data={data}
                cols={cols}
                canLoadMore={canLoadMore}
                isError={isError}
                isLoading={isLoading}
                onPageChange={onPageChange}
                error={error}
                page={page}
            />
        ),
        [canLoadMore, data, error, isError, isLoading, onPageChange, page],
    )

    return <>
        <Box sx={StructuredSearchStyles.exportDataBox}>
            <ExportData exportDataRequest={exportDataActionRequest} />
        </Box>
        <List<AppUserValue> table={accountTable} />
    </>
}
